import { Component, computed } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NotificationBaseComponent } from './notification-base/notification-base.component';

/**
 * Hydrated by Notification.Api from Enrollment.Api (EnrollmentListItem shape) — only the fields the
 * template needs are typed here. It is the enrollment as it is now, so the program is the new one.
 */
interface IEnrollmentProgramChangedData {
	programName: string;
	languageName: string;
}

/**
 * Sent to the instructor when the learner's enrollment moves onto a different program (an upgrade or
 * downgrade). Lessons may have been removed from the end, re-typed, or added as Pending Reschedule.
 */
@Component({
	standalone: true,
	imports: [RouterModule, NotificationBaseComponent],
	selector: 'lb-notification-enrollment-program-changed',
	template: `<lb-notification-base [notification]="notification()">
		<div activity-message>
			moved to the
			<b>{{ enrollment()?.languageName }} {{ enrollment()?.programName }}</b>
			program. Their upcoming lessons were updated to match — check for any that need scheduling.
		</div>
		<div activity-action>
			<button md-button (click)="dismissNotifications()">Dismiss</button>
		</div>
	</lb-notification-base>`,
	styleUrls: ['./notification-base-shared.component.scss']
})
export class NotificationEnrollmentProgramChangedComponent extends NotificationBaseComponent {
	enrollment = computed(() => this.notification().data as IEnrollmentProgramChangedData);
}
